import { ref } from "vue";
import { useEventListener } from "@vueuse/core";
import { resolveFeatureHintAnchor } from "@/src/design_system/feedback/feature_hint/utils/anchor";

interface UseFeatureHintAnchorOptions {
  hintKey: () => string;
  /** The user clicked the anchored element, i.e. used the feature the hint introduces. */
  onActivate: () => void;
}

export const useFeatureHintAnchor = ({ hintKey, onActivate }: UseFeatureHintAnchorOptions) => {
  const anchorElement = ref<HTMLElement | null>(null);
  useEventListener(anchorElement, "click", onActivate);

  const acquire = (): HTMLElement | null => {
    anchorElement.value = resolveFeatureHintAnchor(hintKey());
    return anchorElement.value;
  };

  const release = () => {
    anchorElement.value = null;
  };

  return { anchorElement, acquire, release };
};
